function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M49.5 12.612A26.867 26.867 0 0036 9C21.088 9 9 21.088 9 36 9 50.91 21.088 63 36 63S63 50.91 63 36c0-5.78-3.063-12.826-4.907-15.526M53.55 15.46c.544.461 1.055.931 1.533 1.407",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M44.562 21.633l-.496.495m-3.469 3.469l-3.964 3.964a1 1 0 01-1.414 0l-8.27-8.269a1 1 0 00-1.413 0l-4.243 4.243a1 1 0 000 1.414l8.269 8.27a1 1 0 010 1.413l-8.27 8.27a1 1 0 000 1.414l4.243 4.242a1 1 0 001.415 0l8.269-8.269a1 1 0 011.414 0l7.93 7.93a1 1 0 001.413 0l4.243-4.243a1 1 0 000-1.415l-7.93-7.929a1 1 0 010-1.414l7.93-7.929a1 1 0 000-1.414l-2.122-2.121",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M34.318 1.983a34.447 34.447 0 00-13.593 3.21 34.679 34.679 0 00-13.54 11.265M3.19 23.777a34.422 34.422 0 011.417-3.107M36.764 70.596a34.447 34.447 0 0013.663-2.894 34.679 34.679 0 0013.798-10.949m4.163-7.224a34.42 34.42 0 01-1.49 3.073",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "/img/error.svg";
export { SvgError as ReactComponent };